export default "__VITE_ASSET__067ff139__"